import styled from 'styled-components';

const RowAttribute = styled.div`
    margin-bottom: 40px;
`;

export default { RowAttribute };
